import { useMemo } from 'react';
import { useIntl } from "react-intl";

import { CAR_CO2_EMISSION_CLASSES } from '../constants';

export const useCarCO2EmissionClassList = () => {
  const { formatMessage } = useIntl();

  return useMemo(() => ([
    {
      value: `${formatMessage({ id: "co2EmissionClass" })} I`,
      key: CAR_CO2_EMISSION_CLASSES.class1,
    },
    {
      value: `${formatMessage({ id: "co2EmissionClass" })} II`,
      key: CAR_CO2_EMISSION_CLASSES.class2,
    },
    {
      value: `${formatMessage({ id: "co2EmissionClass" })} III`,
      key: CAR_CO2_EMISSION_CLASSES.class3,
    },
    {
      value: `${formatMessage({ id: "co2EmissionClass" })} IV`,
      key: CAR_CO2_EMISSION_CLASSES.class4,
    },
    {
      value: `${formatMessage({ id: "co2EmissionClass" })} V`,
      key: CAR_CO2_EMISSION_CLASSES.class5,
    },
  ]), [formatMessage]);
};
